import React from "react";
import type { SubjectAssignment } from "../types/subject";
import { groupMembers } from "../utils/subjects";
export function SubjectLetter({
  assignment
}: {
  assignment: SubjectAssignment;
}) {
  const members = groupMembers(assignment.team);
  return <>
      <div className="flex items-baseline justify-between" data-id="element-697" data-mp="1p504eo22549z">
        <p className="text-sm font-semibold sm:text-base" data-id="element-698" data-mp="1k5dpma6kzfz2">Group {assignment.team}</p>
        <p className="text-xs text-navy/60 sm:text-sm" data-id="element-699" data-mp="2gt9yesvs16zq">Project track</p>
      </div>
      <p className="mt-2 border-t border-navy/10 pt-2 text-2xl font-bold leading-tight tracking-tight sm:text-3xl" data-id="element-700" data-mp="2cs7z6c1v0uxr">
        {assignment.subject}
      </p>
      <p className="mt-2 flex flex-wrap gap-x-3 gap-y-0.5 text-sm" data-id="element-701" data-mp="27zwxb3nk6z2k">
        {members.map(m => <span key={m.name} className={`font-semibold ${m.school === "link" ? "text-brgreen" : "text-saffron-dark"}`} data-id="element-702" data-mp="230u4qiormlbh">
            {m.name}
          </span>)}
      </p>
    </>;
}